module.exports = __webpack_public_path__ + "static/media/AK_8.e4fbb91b.jpeg";